import React from "react";
import { useTranslation } from "react-i18next";
import roundButtonStyles from "features/shared/components/buttons/roundbutton.module.scss";

type Props = {
  forAdminUse?: boolean;
};

const ContractingSimplifiedHeader = ({ forAdminUse = false }: Props) => {
  // translations
  const tLabels = useTranslation("contracting\\contracting").t;

  // helpers
  const getEffectiveDateClass = () => {
    return forAdminUse
      ? "d-none d-lg-block col"
      : "d-none d-sm-block col text-center text-lg-left";
  };

  // sub-renders
  const renderActionsHeader = () => {
    if (forAdminUse) {
      return (
        <>
          <div className="d-none d-sm-flex justify-content-end">
            <div className={`btn btn-sm ${roundButtonStyles.roundBtn} mr-2 invisible`} />
            <div className={`btn btn-sm ${roundButtonStyles.roundBtn} invisible`} />
          </div>
          <div className="d-flex d-sm-none justify-content-end">
            <div className={`btn btn-sm ${roundButtonStyles.roundBtn} invisible`} />
          </div>
        </>
      );
    }

    return (
      <div className="d-flex justify-content-end">
        <div className={`btn btn-sm ${roundButtonStyles.roundBtn} invisible`} />
      </div>
    );
  };

  // render
  return (
    <div className="px-3 mb-2 text-muted font-weight-bold">
      <div className="row no-gutters align-items-center">
        <div className="col">
          <div className="row no-gutters align-items-center">
            <div className="col-7 col-sm pr-3">{tLabels("contractingSimplifiedHeader.identification")}</div>
            {forAdminUse && (
              <div className="d-none d-md-block col pr-3">{tLabels("contractingSimplifiedHeader.customer")}</div>
            )}
            <div className={getEffectiveDateClass()}>{tLabels("contractingSimplifiedHeader.effectiveDate")}</div>
            <div className="d-none d-lg-block col">{tLabels("contractingSimplifiedHeader.createdDate")}</div>
            <div className="col-5 col-sm">
              {tLabels("contractingSimplifiedHeader.contractingState")}
              <span className="d-lg-none">/</span>
              <span className="d-lg-none">{tLabels("contractingSimplifiedHeader.createdDate")}</span>
            </div>
            {forAdminUse && (
              <div className="d-none d-xl-block col">{tLabels("contractingSimplifiedHeader.note")}</div>
            )}
          </div>
        </div>
        <div className="col-auto pl-3">{renderActionsHeader()}</div>
      </div>
    </div>
  );
};

export default ContractingSimplifiedHeader;
